/* eslint-disable complexity */
import Button from 'common/components/Button'
import Divider from 'common/components/Divider'
import Flex from 'common/components/Flex'
import UserProfileButton from 'common/components/Header/HeaderUserButtonGroup/UserProfileButton'
import Popover from 'common/components/Popover'
import Profile from 'common/components/Profile'
import Skeleton from 'common/components/Skeleton'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import ThemeColorHelper from 'lib/theme-color-helper'
import React from 'react'
import PopoverCart from 'services/Cart/widgets/PopoverCart'
import Notification from 'services/Notification/widgets/Notification'
import { useStoreState } from 'stores/hooks'
import styled from 'styled-components'

const StyledFlex = styled(Flex)`
  flex-shrink: 0;
  align-items: center;
`

const NotifIconContainer = styled.span`
  display: flex;
  position: relative;
  margin-right: 20px;
`

const CartIconContainer = styled.div`
  display: flex;
  position: relative;
  margin-right: 11px;
`

const StyledSkeleton = styled(Skeleton)`
  display: inline-block;
  margin: ${(props) => props.margin};
  border-radius: ${(props) => props.borderRadius};
`

interface IHeaderUserButtonGroup {
  isLogin?: boolean
  onOpenOverlay: () => void
  onCloseOverlay: () => void
  onOpenRalaliPlusModal: () => void
  isFeatureSetAndChangePinEnable?: boolean
  isMarketplaceCartEnabled?: boolean
}

function HeaderUserButtonGroup({
  isLogin,
  onCloseOverlay,
  onOpenOverlay,
  onOpenRalaliPlusModal,
  isFeatureSetAndChangePinEnable,
  isMarketplaceCartEnabled,
}: IHeaderUserButtonGroup): JSX.Element {
  const {
    profile: { profileData, isLoading, isError },
  } = useStoreState((state) => state)

  const renderContent = (): JSX.Element => {
    if (isLogin) {
      return (
        <>
          <Divider
            width="1px"
            height="30px"
            color={theme.colors.grayLight}
            margin="0 20px 0 0"
          />
          {isMarketplaceCartEnabled && (
            <CartIconContainer data-testid="cart-container">
              <PopoverCart
                isLogin={isLogin}
                onOpenOverlay={onOpenOverlay}
                onCloseOverlay={onCloseOverlay}
              />
            </CartIconContainer>
          )}
          <NotifIconContainer data-testid="notification-container">
            <Notification
              isLogin={isLogin}
              onOpenOverlay={onOpenOverlay}
              onCloseOverlay={onCloseOverlay}
            />
          </NotifIconContainer>
          <Divider
            width="1px"
            height="30px"
            color={theme.colors.grayLight}
            margin="0 20px 0 0"
          />
          <Popover
            full
            content={
              // eslint-disable-next-line react/jsx-wrap-multilines
              <Profile
                name={profileData !== null ? profileData?.name : ''}
                imageProfile={
                  profileData !== null
                    ? profileData?.profile_picture
                    : ''
                }
                isLoading={isLoading}
                isError={isError}
                handleOpenRalaliPlusModal={onOpenRalaliPlusModal}
                pinStatus={profileData?.pin_status}
                isHandphoneVerified={
                  profileData?.is_handphone_verified
                }
                isFeatureSetAndChangePinEnable={
                  isFeatureSetAndChangePinEnable
                }
              />
            }
            onOpenOverlay={onOpenOverlay}
            onCloseOverlay={onCloseOverlay}
            side="bottom"
            position="left"
          >
            {(isLoading || isError) && (
              <StyledSkeleton
                height="34px"
                width="34px"
                borderRadius="50%"
                margin="0"
              />
            )}
            {!isLoading && !isError && (
              <UserProfileButton
                imageProfile={profileData?.profile_picture}
              />
            )}
          </Popover>
        </>
      )
    }

    return (
      <Flex gap="6px">
        <a href={`${WEB_DESKTOP_RALALI_URL}/login`}>
          <Button
            color={ThemeColorHelper('primary')}
            borderRadius={theme.radius.xl}
            type="button"
            variant="contained"
          >
            Masuk
          </Button>
        </a>
        <a href={`${WEB_DESKTOP_RALALI_URL}/signup`}>
          <Button
            color="black"
            borderRadius={theme.radius.xl}
            type="button"
            variant="outlined"
          >
            Daftar
          </Button>
        </a>
      </Flex>
    )
  }

  return (
    <StyledFlex alignItems="center">
      <>{renderContent()}</>
    </StyledFlex>
  )
}

export default HeaderUserButtonGroup
